// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1898":"9564bd08","3449":"2d7c7882","4616":"8c18f848"}[chunkId] + ".chunk.css";
};